import { useEffect } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";
import { PAYMENT_ACCOUNTING_ROLES, SOURCE_LABELS } from "../utils/konfipay";

/** Tells accounting about new payment orders; the page itself refreshes on the same event. */
export function useKonfipayNotifications() {
  const { user, isAuthenticated } = useAuth();
  const isAccounting = isAuthenticated && PAYMENT_ACCOUNTING_ROLES.includes(user?.role);

  useEffect(() => {
    if (!isAccounting) return undefined;
    const onCreated = (event) => {
      const source = SOURCE_LABELS[event.detail?.source] || "Zahlung";
      toast.info(`Neuer Zahlungsauftrag zur Freigabe (${source})`, { toastId: `konfipay-${event.detail?.id}` });
    };
    window.addEventListener("konfipay_payment_created", onCreated);
    return () => window.removeEventListener("konfipay_payment_created", onCreated);
  }, [isAccounting]);
}
